import { Box, Flex } from "@chakra-ui/react";
import { useState, useCallback, memo } from "react";
import ColorModeToggle from "@/components/color-mode-toggle";
import Sidebar from "@/components/Sidebar";

interface LayoutProps {
  children: React.ReactNode;
}

// Layout styles using design tokens
const layoutStyles = {
  minH: "100vh",
  bg: "gray.50",
  _dark: { bg: "gray.900" },
};

const getContentStyles = (isCollapsed: boolean) => ({
  flex: 1,
  ml: isCollapsed ? "16" : "64",
  pos: "relative" as const,
  transition: "margin-left 0.3s ease-in-out",
});

const toggleStyles = {
  pos: "absolute" as const,
  top: 4,
  right: 4,
  zIndex: 5,
};

const mainContentStyles = {
  p: 8,
  overflow: "auto" as const,
};

const Layout = memo(function Layout({ children }: LayoutProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = useCallback(() => {
    setIsCollapsed(prev => !prev);
  }, []);

  return (
    <Flex {...layoutStyles}>
      <Sidebar 
        isCollapsed={isCollapsed} 
        onToggle={toggleSidebar}
      />
      
      <Box {...getContentStyles(isCollapsed)}>
        {/* Color mode toggle */}
        <Box {...toggleStyles}>
          <ColorModeToggle />
        </Box>
        
        {/* Main content */}
        <Box {...mainContentStyles}>
          {children}
        </Box>
      </Box>
    </Flex>
  );
});

export default Layout; 
